import { Outlet } from "react-router-dom";
import Header from "../components/molecules/Header";
import Menu from "../components/organisms/Menu";
import { theme } from "../theme";

export default function ProtectedLayout() {
  return (
    <div
      style={{
        backgroundColor: theme.colors.grey02,
        overflow: "clip",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Header />
      <div style={{ display: "flex", flexGrow: 1 }}>
        <Menu />
        <div
          style={{
            padding: 32,
            flexGrow: 1,
            boxSizing: "border-box",
            minWidth: 0,
          }}
        >
          <Outlet />
        </div>
      </div>
    </div>
  );
}
